import { Skeleton } from "@wa/ui";

/**
 * A list that has not answered yet, drawn in the shape of the list.
 *
 * Rows of the same height as the real ones, so the page does not jump when the
 * records land. The region carries the spoken "loading" (`label`, from the
 * catalogue); the grey blocks themselves say nothing to a screen reader.
 */
export function ListSkeleton({ rows = 4, label }: { rows?: number; label: string }) {
  return (
    <div role="status" aria-busy="true" aria-label={label} className="divide-y divide-border">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center gap-4 px-5 py-4">
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton className="h-4 w-40 max-w-full" />
            <Skeleton className="h-3 w-56 max-w-full" />
          </div>
          <Skeleton className="h-4 w-16 max-sm:hidden" />
          <Skeleton className="h-6 w-20 rounded-full" />
        </div>
      ))}
    </div>
  );
}
